<template>
      <v-card>
          <v-card-title class="headline primary white--text">
              Cadastro de Cliente
          </v-card-title>

          <v-stepper v-model="step">
              <v-stepper-header>
                  <v-stepper-step step="1" :complete="step > 1">Dados Pessoais</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step step="2">Endereço</v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                  <!-- Passo 1 - Dados Pessoais -->
                  <v-stepper-content step="1">
                      <v-form ref="formStep1" v-model="validStep1" lazy-validation>
                          <v-container grid-list-md>
                              <v-layout wrap>
                                  <v-flex xs12>
                                      <v-text-field
                                          label="CPF*"
                                          v-model.lazy="cliente.cpf"
                                          mask="###.###.###-##"
                                          :rules="cpfRules"
                                          outline
                                      />
                                  </v-flex>

                                  <v-flex xs12 sm6>
                                      <v-text-field
                                        label="Nome*"
                                        v-model="cliente.nome"
                                        :rules="nomeRules"
                                        required
                                        outline
                                        :readonly="!!pessoa && !!pessoa.nome"
                                      />
                                  </v-flex>

                                  <v-flex xs12 sm6>
                                      <v-text-field
                                        label="Sobrenome*"
                                        v-model="cliente.sobrenome"
                                        :rules="sobrenomeRules"
                                        outline
                                        :readonly="!!pessoa && !!pessoa.sobrenome"
                                      />
                                  </v-flex>

                                  <v-flex xs12 sm6>
                                      <v-text-field
                                        label="Telefone*"
                                        v-model.lazy="cliente.telefone"
                                        mask="(##) #####-####"
                                        :rules="telefoneRules"
                                        outline
                                        :readonly="!!pessoa && !!pessoa.telefone"
                                      />
                                  </v-flex>

                                  <v-flex xs12 sm6 v-if="step === 1">
                                      <v-text-field
                                        label="Data de Nascimento*"
                                        v-model="cliente.data_nascimento"
                                        v-mask="'##/##/####'"
                                        :rules="nascimentoRules"
                                        placeholder="DD/MM/AAAA"
                                        outline
                                        :readonly="!!pessoa && !!pessoa.data_nascimento"
                                      />
                                  </v-flex>

                                  <v-flex xs12>
                                      <v-text-field
                                        label="E-mail*"
                                        v-model="cliente.email"
                                        :rules="emailRules"
                                        outline
                                        :readonly="!!pessoa && !!pessoa.email"
                                      />
                                  </v-flex>
                              </v-layout>
                          </v-container>
                      </v-form>
                      <v-card-actions class="justify-space-around mt-4">
                          <v-btn color="error" @click="fecharCard">Cancelar</v-btn>
                          <v-btn color="primary" @click="nextStep" :disabled="!validStep1">Próximo</v-btn>
                      </v-card-actions>
                  </v-stepper-content>

                  <!-- Passo 2 - Endereço -->
                  <v-stepper-content step="2">
                      <v-form ref="formStep2" v-model="validStep2" lazy-validation>
                          <v-container grid-list-md>
                              <v-layout wrap>

                                <v-flex xs12 sm12>
                                  <v-text-field
                                    label="CEP*"
                                    @keyup="searchCep()"
                                    v-model="cliente.endereco.cep"
                                    mask="#####-###"
                                    :rules="cepRules"
                                    outline
                                    required
                                  >
                                    <template v-slot:append>
                                      <v-icon
                                        color="primary"
                                        @click="searchCep()"
                                        :disabled="!cliente.endereco.cep || cliente.endereco.cep.replace(/\D/g, '').length !== 8"
                                      >
                                        search
                                      </v-icon>
                                    </template>
                                  </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                  <v-text-field
                                    label="Logradouro*"
                                    v-model="cliente.endereco.logradouro"
                                    :rules="logradouroRules"
                                    outline
                                    :disabled="!cepValido"
                                  />
                                </v-flex>

                                <v-flex xs12 sm3>
                                  <v-text-field
                                    label="Número*"
                                    v-model="cliente.endereco.numero"
                                    :rules="numeroRules"
                                    required
                                    type="number"
                                    outline
                                    :disabled="!cepValido"
                                  />
                                </v-flex>

                                <v-flex xs12 sm4>
                                  <v-text-field
                                    label="Complemento"
                                    v-model="cliente.endereco.complemento"
                                    outline
                                    :disabled="!cepValido"
                                  />
                                </v-flex>

                                <v-flex xs12 sm5>
                                  <v-text-field
                                    label="Bairro*"
                                    v-model="cliente.endereco.bairro"
                                    :rules="bairroRules"
                                    required
                                    outline
                                    :disabled="!cepValido"
                                  />
                                </v-flex>

                                <v-flex xs12 sm6>
                                  <v-text-field
                                    label="Cidade*"
                                    v-model="cliente.endereco.cidade"
                                    :rules="cidadeRules"
                                    required
                                    outline
                                    :disabled="!cepValido"
                                  />
                                </v-flex>

                                <v-flex xs12 sm6>
                                  <v-select
                                    label="Estado*"
                                    v-model="cliente.endereco.estado"
                                    :items="estados"
                                    :rules="estadoRules"
                                    outline
                                    required
                                    :disabled="!cepValido"
                                  />
                                </v-flex>

                              </v-layout>
                          </v-container>
                      </v-form>

                      <v-card-actions class="justify-space-around mt-4">
                          <v-btn @click="step = 1">Voltar</v-btn>
                          <v-btn color="success" @click="salvar" :disabled="!validStep2" :loading="loading">Salvar</v-btn>
                      </v-card-actions>
                  </v-stepper-content>
              </v-stepper-items>
          </v-stepper>
  </v-card>
</template>

<script>
import Vue from 'vue'
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

export default {
  props: ['cpf'],
  data: () => ({
    step: 1,
    validStep1: true,
    validStep2: true,
    pessoa: undefined,
    telefone_existe: false,
    email_existe: false,
    cepValido: false,
    estados: ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'],
    cliente: {
      nome: '',
      sobrenome: '',
      telefone: '',
      cpf: '',
      email: '',
      data_nascimento: '',
      endereco: {
        logradouro: '',
        numero: '',
        bairro: '',
        cidade: '',
        estado: '',
        cep: ''
      }
    },
    // Regras de validação
    nomeRules: [
      v => !!v || 'Nome é obrigatório',
      v => (v && v.length <= 50) || 'Nome deve ter menos de 50 caracteres'
    ],
    sobrenomeRules: [
      v => !!v || 'Sobrenome é obrigatório'
    ],
    telefoneRules: [],
    cpfRules: [
      v => !!v || 'CPF é obrigatório',
      v => v.replace(/\D/g, '').length === 11 || 'CPF inválido'
    ],
    nascimentoRules: [
      v => !!v || 'Data de nascimento é obrigatória',
      v => /^(\d{2})\/(\d{2})\/(\d{4})$/.test(v) || 'Formato inválido (DD/MM/AAAA)'
    ],
    emailRules: [],
    logradouroRules: [v => !!v || 'Logradouro é obrigatório'],
    numeroRules: [v => !!v || 'Número é obrigatório'],
    bairroRules: [v => !!v || 'Bairro é obrigatório'],
    cidadeRules: [v => !!v || 'Cidade é obrigatória'],
    estadoRules: [v => !!v || 'Estado é obrigatório'],
    cepRules: [
      v => !!v || 'CEP é obrigatório',
      v => v.replace(/\D/g, '').length === 8 || 'CEP inválido'
    ]
  }),
  computed: {
    loading () {
      return this.$store.getters.loading
    }
  },
  beforeMount () {
    if (this.cpf) {
      this.cliente.cpf = this.cpf
    }
    this.emailRules = [
      v => !!v || 'E-mail é obrigatório',
      v => /.+@.+\..+/.test(v) || 'E-mail deve ser válido',
      v => !this.email_existe || 'E-mail já cadastrado'
    ]
    this.telefoneRules = [
      v => !!v || 'Telefone é obrigatório',
      v => v.replace(/\D/g, '').length === 11 || 'Telefone inválido',
      v => {
        if (!this.telefone_existe) return true
        if (this.pessoa && this.pessoa.telefone === v.replace(/\D/g, '')) {
          return true
        }
        return 'Telefone já cadastrado por outro cliente'
      }// (this.telefone_existe || (this.pessoa && this.pessoa.telefone !== v)) || 'Telefone já cadastrado' // && (!this.pessoa || this.pessoa.telefone !== v))
    ]
  },
  watch: {
    pessoa (val) {
      if (val) {
        this.cliente.id_pessoa = val.id_pessoa
        this.cliente.nome = val.nome
        this.cliente.sobrenome = val.sobrenome
        this.cliente.telefone = val.telefone
        this.cliente.cpf = val.cpf
        this.cliente.data_nascimento = val.data_nascimento ? val.data_nascimento.split('-').reverse().join('/') : ''
        this.cliente.email = val.email
        if (val.endereco) {
          this.cliente.endereco.logradouro = val.endereco.logradouro
          this.cliente.endereco.numero = val.endereco.numero
          this.cliente.endereco.bairro = val.endereco.bairro
          this.cliente.endereco.cidade = val.endereco.cidade
          this.cliente.endereco.estado = val.endereco.estado
          this.cliente.endereco.cep = val.endereco.cep
          this.cliente.endereco.complemento = val.endereco.complemento
        }
      }
    },
    'cliente.cpf' (val) {
      if (val && val.length === 11) {
        this.pesquisarPessoa({
          cpf: val.replace(/\D/g, '')
        })
      }
    },
    'cliente.email' (val) {
      if (val && val.length > 0 && !this.pessoa) {
        this.pesquisarPessoa({
          email: val
        })
      }
    },
    'cliente.telefone' (val) {
      if (val && val.length === 11 && !this.pessoa) {
        this.pesquisarPessoa({
          telefone: val.replace(/\D/g, '')
        })
      }
    },
    cpf (val) {
      if (val) {
        this.cliente.cpf = val
      }
    }
  },
  methods: {
    nextStep () {
      if (this.$refs.formStep1.validate()) {
        this.step = 2
      }
    },
    async buscarCoordenadas () {
      const json = await this.$store.dispatch('pegarCoordenadas', {
        logradouro: this.cliente.endereco.logradouro,
        numero: this.cliente.endereco.numero,
        bairro: this.cliente.endereco.bairro,
        cidade: this.cliente.endereco.cidade,
        estado: this.cliente.endereco.estado
      })

      if (!json || !json.latitude || !json.longitude) {
        return
      }
      this.cliente.endereco.latitude = json.latitude
      this.cliente.endereco.longitude = json.longitude
    },
    searchCep () {
      this.cepValido = false
      if (!this.cliente.endereco.cep || this.step !== 2) return
      if (this.cliente.endereco.cep.length !== 8) return
      fetch(`https://viacep.com.br/ws/${this.cliente.endereco.cep}/json/`,
        {
          method: 'get',
          mode: 'cors',
          headers: { 'Accept': 'application/json' }
        })
        .then(res => res.json())
        .then(json => {
          this.cliente.endereco.logradouro = json.logradouro
          this.cliente.endereco.bairro = json.bairro
          this.cliente.endereco.cidade = json.localidade
          this.cliente.endereco.estado = json.uf
          this.cepValido = true
        })
    },
    async salvar () {
      if (this.$refs.formStep2.validate()) {
        await this.buscarCoordenadas()
        if (this.cliente.data_nascimento && !this.cliente.data_nascimento.includes('-')) {
          this.cliente.data_nascimento = this.cliente.data_nascimento.split('/').reverse().join('-')
        }
        this.$store.dispatch('gerenciarUsuario', {
          method: 'POST',
          body: this.cliente
        }).then(() => {
          this.$emit('cadastroRealizado')
          this.fecharCard()
        })
      }
    },
    limpar () {
      this.$refs.formStep1.reset()
      this.$refs.formStep2.reset()
      this.step = 1
      this.pessoa = undefined
      this.telefone_existe = false
      this.email_existe = false
    },
    fecharCard () {
      this.limpar()
      this.$emit('fechar')
    },
    pesquisarPessoa (data) {
      this.$store.dispatch('pesquisarPessoa', data).then(json => {
        const item = json.length > 0 ? json[0] : undefined
        if (data.telefone) {
          this.telefone_existe = !!item
        } else if (data.email) {
          this.email_existe = !!item
        } else if (data.cpf) {
          if (item) this.pessoa = item
          else this.pessoa = undefined
        }
      })
    }
  }
}
</script>

<style scoped>
.headline {
    padding: 16px 24px;
}

.v-card__actions {
    padding: 16px 24px;
}
</style>
